import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useStateWithSearchParams } from "../../hooks";

const tabList = [
  {
    label: "Account Insights",
    path: "account",
  },
  {
    label: "Reports",
    path: "reports",
  },
];

export const AccountReportsTabs = ({
  isNeedUpdate,
  isDisabled,
}: {
  isNeedUpdate: boolean;
  isDisabled: boolean;
}) => {
  const { searchDict, setSearchValue, clearAll } = useStateWithSearchParams<{
    tab?: string;
  }>({
    tab: tabList[0].path,
  });

  const isReports = tabList[1].path === searchDict.tab;

  const handleChange = (e: React.SyntheticEvent, idx: number) => {
    if (idx === 1) setSearchValue("tab", "reports");
    else clearAll();
  };

  return (
    <Box
      sx={{
        display: "flex",
        borderBottom: "1px solid #D9D9D9",
        justifyContent: "space-between",
        alignItems: "flex-end",
      }}
    >
      <Tabs
        value={isReports ? 1 : 0}
        onChange={handleChange}
        sx={{
          borderBottom: "none",
        }}
      >
        {tabList.map(({ label }, index) => (
          <Tab
            key={label}
            label={label}
            disabled={tabList.length - 1 === index && isDisabled}
            sx={{
              width: "fit-content",
              textWrap: "nowrap",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "24px",
              "&.Mui-selected": { color: "#1C3C6C" },
              ...(tabList.length - 1 === index &&
                isNeedUpdate && {
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 14,
                    right: 10,
                    width: "6px",
                    height: "6px",
                    backgroundColor: "#FD8430",
                    borderRadius: "50%",
                  },
                }),
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
